import React, { useEffect, useState, useCallback } from "react";
import "./ScrollTopButton.css";

export default function ScrollTopButton({
  threshold = window?.innerHeight ?? 600, // show after one viewport by default
  ariaLabel = "Scroll to top"
}) {
  const [visible, setVisible] = useState(false);

  // throttle using rAF pattern to avoid many setState calls
  useEffect(() => {
    let ticking = false;
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const show = window.scrollY > threshold;
          setVisible(show);
          ticking = false;
        });
        ticking = true;
      }
    }

    // Attach
    window.addEventListener("scroll", onScroll, { passive: true });
    // run on mount in case page already scrolled
    onScroll();

    return () => {
      window.removeEventListener("scroll", onScroll, { passive: true });
    };
  }, [threshold]);

  const scrollToTop = useCallback(() => {
    // smooth scroll; browser will handle it
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <button
      className={`scroll-top-btn ${visible ? "show" : ""}`}
      onClick={scrollToTop}
      aria-label={ariaLabel}
      title="Back to top"
    >
        <strong>&uarr;</strong>
    </button>
  );
}
